import axios from 'axios';
import { AccountCompany } from 'contexts/account/types/account-company.type';

// GET
// /ewosapi/v1/me/granted/companies/{includeSitesData}
export const getCompanies = async (includeSitesData: boolean): Promise<AccountCompany[]> => {
  const res = await axios.get(`/ewosapi/v1/me/granted/companies/${includeSitesData}`);
  return res.data;
};
